import type { FC } from 'react'
import ProceedToCheckout from '../buttons/ProceedToCheckout'
import ViewCart from '../buttons/ViewCart'

const AddToCartConfirmationButtons: FC = () => (
  <div className="flex space-x-4 h-16 sm:h-12">
    <ViewCart className="h-full" color="secondary" />
    <ProceedToCheckout />
  </div>
)

export default AddToCartConfirmationButtons
